import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';
import { statusCheck } from '../public';
import Swal from 'sweetalert2';


export const useMemberStore = defineStore('member', {
  state: () => ({
    members: [],
    totalEntries: 0,
    currentPage: 1,
    itemsPerPage: 10,
    sort_by:'first_name',
    order:'desc',
  }),
  actions: {
    async fetchMembers() {
      const url = `/api/admin/member/list?per_page=${this.itemsPerPage}&page=${this.currentPage}&sort_by=${this.sort_by}&order=${this.order}`;
      try {
        const response = await useHttp().get(url);
        this.members = response.data.members;
        this.totalEntries = response.data.total;
      } catch (error) {
        console.error('Error fetching members:', error);
        throw error;
      }
    },
    async createMember(payload) {
        try {
          const response = await useHttp().post('/api/admin/member/create', {
            first_name: payload.first_name,
            middle_name: payload.middle_name,
            last_name: payload.last_name,
            username: payload.username,
            password: payload.password,
            role_id: payload.role_id,
            enabled: payload.enabled
          });
            if(statusCheck(response.data)){
                Swal.fire({
                    icon: "success",
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 1500
                });
                this.fetchMembers();
            }
        } catch (error) {
          console.error('Error creating member:', error);
          throw error;
        }
    },
    async updateMember(payload) {
      try {
        const response = await useHttp().post('/api/admin/member/update', {
          id: payload.id,
          first_name: payload.first_name,
          middle_name: payload.middle_name,
          last_name: payload.last_name,
          username: payload.username,
          password: payload.password,
          role_id: payload.role_id,
          enabled: payload.enabled
        });
        if(statusCheck(response.data)){
          Swal.fire({
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          await this.fetchMembers();
        }
      } catch (error) {
        console.error('Error updating member:', error);
        throw error;
      }
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchMembers();
      }
    },
  },
  getters: {
    paginatedData(state) {
      return state.members;
    },
    totalPages(state) {
      return Math.ceil(state.totalEntries / state.itemsPerPage);
    },
  },
});
